var _document_querySelectorAll;
var $header = document.querySelector('.header');
window.searchTab = function(name) {
    // if(window.location.hash.length > 0){
    // 	window.lenis.scrollTo('#rooms-tabs', {
    // 		duration: 1,
    // 		lock: true,
    // 		offset: -$header.clientHeight * 1.5
    // 	})
    // }
    var $current = document.querySelector('[data-room-tab].rooms-tabs__item_open');
    var $next = document.querySelector('[data-room-tab="'.concat(name, '"]'));
    $current.classList.remove('rooms-tabs__item_visible');
    var timeout = setTimeout(function() {
        $current.classList.remove('rooms-tabs__item_open');
        $next.classList.add('rooms-tabs__item_open');
        $next.classList.add('rooms-tabs__item_visible');
        var url = window.location.href;
        // if (!url.includes('#apartments')) {
        //   url += '#apartments';
        // }
        window.history.pushState(null, null, url);
        window.dispatchEvent(new CustomEvent('tabChange', {
            detail: {
                name: name
            }
        }));
        clearTimeout(timeout);
    }, 200);
};
var params = "";
(_document_querySelectorAll = document.querySelectorAll('[data-room-tab-change]')) === null || _document_querySelectorAll === void 0 ? void 0 : _document_querySelectorAll.forEach(function($item) {
    $item.addEventListener('click', function(event) {
        event.preventDefault();
        window.searchTab($item.dataset.roomTabChange);
        console.log($item.dataset.roomTabChange);
    });
    params = $item.dataset.roomTabChange;
});
if (window.location.href.split("?")[1] == "params") {
    if (window.hasOwnProperty('searchTab')) {
        window.searchTab("params");
    }
}
document.addEventListener('scroll', function() {
    var blocks = document.querySelectorAll('.section__anchor');
    var currentHash = '';
    blocks.forEach(function(block) {
        var rect = block.getBoundingClientRect();
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
            currentHash = '#' + block.id;
        }
    });
    if (currentHash && window.location.hash !== currentHash) {
        window.history.pushState(null, '', currentHash);
    }
});
